/* eslint-disable */
(function (window) {
    window.recaptchaData = window.recaptchaData || {};
    window.recaptchaData.recaptchaEventsHolder = window.recaptchaData.recaptchaEventsHolder || {};
    window.recaptchaData.recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr || [];

    window.onRecaptchaLoad = function () {
        var recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr;
        for (var i = 0; i < recaptchaCallbacksArr.length; i += 1) {
            if (typeof recaptchaCallbacksArr[i] === 'function') {
                recaptchaCallbacksArr[i]();
            }
        }

        window.recaptchaData.recaptchaCallbacksArr = [];
    };
}(window));
/* eslint-enable */

/**
 * Injects the Google reCAPTCHA script tag exactly once (flag shared across all
 * bundled copies of this module via window.recaptchaData).
 *
 * PRIVACY/CONSENT NOTE (GDPR/CPRA data minimization): this is deliberately NOT
 * called on page load. Google reCAPTCHA collects device/behavioral signals, so
 * the script may only be requested when it becomes strictly necessary for the
 * action the shopper is performing: first interaction with a protected form
 * (see attach) or an explicit risk-triggered call (see stripe.checkout.js).
 */
function loadScript() {
    if (window.grecaptcha || window.recaptchaData.scriptRequested) {
        return;
    }
    window.recaptchaData.scriptRequested = true;

    var url = window.SitePreferences.RECAPTCHA_API_URL;
    var script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}

module.exports = {
    /**
     * Kept as a no-op so existing call sites need no changes. The Google
     * script is no longer loaded at page load; loading is deferred until the
     * shopper interacts with an attached form (or loadScript is called at a
     * risk-triggered moment).
     */
    init: function () {
        // intentionally empty — loading is interaction-triggered (see attach/loadScript)
    },

    loadScript: loadScript,

    attach: function (form, callback, invisible) {
        var $holder = form.find('.js-recaptcha-input')[0];
        var recaptchaData = {
            sitekey: window.SitePreferences.RECAPTCHA_SITE_KEY,
            callback: typeof callback === 'function' ? callback : null
        };

        if (invisible) {
            recaptchaData.theme = 'light';
            recaptchaData.size = 'invisible';
            recaptchaData.badge = 'bottomright';
            recaptchaData.isolated = true;
        }
        window.recaptchaData.recaptchaCallbacksArr.push(function () {
            var holderId = window.grecaptcha.render($holder, recaptchaData);
            window.recaptchaData.recaptchaEventsHolder[form.attr('name')] = holderId;
        });

        if (window.grecaptcha) {
            // Script already present (another protected form triggered it):
            // render immediately.
            window.onRecaptchaLoad();
        } else {
            // Defer the Google request until the shopper actually starts the
            // protected action. Namespaced one-shot handler so repeated attach
            // calls on the same form don't stack listeners.
            form.off('focusin.recaptcha change.recaptcha')
                .one('focusin.recaptcha change.recaptcha', function () {
                    loadScript();
                });
        }
    },

    showReCaptcha: function (formName) {
        if (window.grecaptcha && formName && formName in window.recaptchaData.recaptchaEventsHolder) {
            window.grecaptcha.execute(window.recaptchaData.recaptchaEventsHolder[formName]);
            return;
        }

        // Widget not rendered yet (e.g. instant autofill + submit before any
        // focus event, or the script is still in flight): queue the challenge
        // to run right after the pending render callbacks, then load.
        window.recaptchaData.recaptchaCallbacksArr.push(function () {
            if (formName && formName in window.recaptchaData.recaptchaEventsHolder) {
                window.grecaptcha.execute(window.recaptchaData.recaptchaEventsHolder[formName]);
            }
        });
        loadScript();
    },

    reset: function (form) {
        if (window.grecaptcha && form.attr('name') in window.recaptchaData.recaptchaEventsHolder) {
            window.grecaptcha.reset(window.recaptchaData.recaptchaEventsHolder[form.attr('name')]);
        }
    }

};
